import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, renderSlot as _renderSlot, unref as _unref, toHandlers as _toHandlers, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode2 } from "vue";
const _hoisted_1 = {
  class: "filter-dropdown-header-wrapper"
};
import { computed, reactive, ref } from 'vue';
import MgQueryFilterForm from './mg-query-filter-form';
export default {
  __name: 'mg-query-filter-dropdown',
  props: {
    items: {
      type: [Array, Object],
      default: () => []
    }
  },
  emits: ['applyFilter', 'cancelFilter', 'resetFilter'],
  setup(__props, {
    emit: __emit
  }) {
    const showFilterForm = ref(false);
    const filterFormRef = ref();
    const formData = ref({});
    const emit = __emit;
    const props = __props;
    const dropdownItems = computed(() => {
      if (Array.isArray(props.items)) {
        return props.items;
      } else if (typeof props.items === 'object') {
        const {
          items = []
        } = props.items;
        return items;
      }
      return [];
    });
    const SlotComponent = ({
      name,
      data
    }) => {
      const slotFn = dropdownSlots.value[name];
      if (!slotFn || typeof slotFn !== 'function') return _createVNode2("span", null, null);
      return slotFn(data);
    };
    const dropdownSlots = computed(() => {
      const isSlotProp = !!props.items && typeof props.items === 'object' && !Array.isArray(props.items) && !!props.items.slots && typeof props.items.slots === 'object';
      if (isSlotProp) {
        const {
          slots = {}
        } = props.items;
        return slots;
      }
      return {};
    });
    const dropdownOptions = reactive({
      placement: 'bottom',
      transfer: true,
      trigger: 'click',
      showPopupShadow: true,
      popupClassName: 'filter-form-wrapper'
    });
    const filterFormEvents = {
      changed(data) {
        formData.value = data;
      },
      filter(data) {
        showFilterForm.value = false;
        formData.value = data || {};
        emit('applyFilter', data || {});
      },
      reset() {
        showFilterForm.value = false;
        formData.value = {};
        emit('resetFilter', {});
      },
      cancel() {
        showFilterForm.value = false;
        emit('cancelFilter');
      }
    };
    const handleSubmit = () => {
      showFilterForm.value = false;
      emit('applyFilter', formData.value || {});
    };
    const handleReset = () => {
      formData.value = {};
      showFilterForm.value = false;
      emit('resetFilter', {});
    };
    const handleCancel = () => {
      showFilterForm.value = false;
      emit('cancelFilter');
    };
    return (_ctx, _cache) => {
      const _component_vxe_button = _resolveComponent("vxe-button");
      const _component_vxe_button_group = _resolveComponent("vxe-button-group");
      const _component_vxe_pulldown = _resolveComponent("vxe-pulldown");
      return _openBlock(), _createBlock(_component_vxe_pulldown, _mergeProps({
        modelValue: showFilterForm.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => showFilterForm.value = $event)
      }, dropdownOptions), {
        default: _withCtx(() => [_createVNode(_component_vxe_button, {
          icon: "vxe-icon-funnel"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("过滤", -1)]))]),
          _: 1
        })]),
        header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_vxe_button_group, null, {
          default: _withCtx(() => [_createVNode(_component_vxe_button, {
            status: "success",
            onClick: handleSubmit
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("提交", -1)]))]),
            _: 1
          }), _createVNode(_component_vxe_button, {
            onClick: handleReset
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("重置", -1)]))]),
            _: 1
          }), _createVNode(_component_vxe_button, {
            status: "danger",
            onClick: handleCancel
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("取消", -1)]))]),
            _: 1
          })]),
          _: 1
        })])]),
        dropdown: _withCtx(() => [_createVNode(_unref(MgQueryFilterForm), _mergeProps({
          ref_key: "filterFormRef",
          ref: filterFormRef,
          "show-action": false,
          items: dropdownItems.value
        }, _toHandlers(filterFormEvents)), _createSlots({
          _: 2
        }, [_renderList(Object.keys(dropdownSlots.value), key => {
          return {
            name: key,
            fn: _withCtx(scope => [_createVNode(SlotComponent, {
              name: key,
              data: scope
            }, null, 8, ["name", "data"])])
          };
        }), _renderList(Object.keys(_ctx.$slots), key => {
          return {
            name: key,
            fn: _withCtx(scope => [_renderSlot(_ctx.$slots, key, _mergeProps({
              key: key
            }, scope))])
          };
        })]), 1040, ["items"])]),
        _: 3
      }, 16, ["modelValue"]);
    };
  }
};